/* Pawsy product pages: gallery, tier buy box, sticky add to cart, scroll
   reveal, ingredient carousel, exclusive accordions. Uses window.pawsy from
   pawsy.js for the cart. */
(function () {
  'use strict';
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };

  /* ---------- gallery ---------- */
  $$('[data-ps-gallery]').forEach(function (g) {
    var track = $('[data-ps-gallery-track]', g);
    var thumbs = $$('[data-ps-thumb]', g);
    var bar = $('[data-ps-gallery-bar]', g);
    var n = track.children.length;
    var rtl = getComputedStyle(track).direction === 'rtl';
    var cur = function () { return Math.round(Math.abs(track.scrollLeft) / track.clientWidth); };
    var go = function (i) { i = (i + n) % n; track.scrollTo({ left: (rtl ? -1 : 1) * i * track.clientWidth, behavior: 'smooth' }); };
    function sync() {
      var i = cur();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (bar) { bar.style.width = (100 / n) + '%'; bar.style.transform = 'translateX(' + (rtl ? -i : i) * 100 + '%)'; }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var next = $('[data-ps-gallery-next]', g);
    next && next.addEventListener('click', function () { go(cur() + 1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    sync();
  });

  /* ---------- buy box ---------- */
  $$('[data-ps-buybox]').forEach(function (bb) {
    var pdp = bb.closest('[data-ps-pdp]');
    var tiers = $$('.ps-tier', bb);
    var atc = $('[data-ps-atc]', bb);
    var totalEl = $('[data-ps-atc-total]', bb);
    var err = $('[data-ps-atc-err]', bb);
    var giftsOn = bb.dataset.gifts === '1';
    var sel = Math.max(0, tiers.findIndex(function (t) { return t.classList.contains('is-on'); }));

    function render() {
      tiers.forEach(function (t, i) {
        var on = i === sel;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      var q = +tiers[sel].dataset.qty;
      $$('.ps-gift', bb).forEach(function (g) { g.classList.toggle('is-on', q >= +g.dataset.unlock); });
      totalEl.innerHTML = '<bdi>' + tiers[sel].dataset.total + '</bdi>';
      doc.dispatchEvent(new CustomEvent('pawsy:tier', { detail: { total: tiers[sel].dataset.total } }));
    }
    function move(i) { sel = (i + tiers.length) % tiers.length; render(); tiers[sel].focus(); }
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { sel = i; render(); });
      t.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); sel = i; render(); }
        else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); move(i + 1); }
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); move(i - 1); }
      });
    });

    // Gifts are real priced products; a BxGy automatic discount makes them
    // free. They unlock by tier and are only added while the toggle is on.
    function giftLines() {
      if (!giftsOn) return [];
      var q = +tiers[sel].dataset.qty, pid = pdp ? pdp.dataset.productId : '';
      return $$('.ps-gift[data-gift-variant]', bb).filter(function (g) { return q >= +g.dataset.unlock; }).map(function (g) {
        return { id: +g.dataset.giftVariant, quantity: 1, properties: { _is_free_gift: 'true', _linked_to_product: String(pid) } };
      });
    }

    atc.addEventListener('click', function () {
      var t = tiers[sel];
      atc.disabled = true; err.hidden = true;
      window.pawsy.addToCart([{ id: +t.dataset.variant, quantity: 1 }].concat(giftLines()))
        .catch(function (e) { err.textContent = e.message; err.hidden = false; })
        .then(function () { atc.disabled = false; });
    });
    render();

    /* sticky add to cart: shows once the real button has scrolled above the
       viewport, and forwards clicks to it so there is one cart code path. */
    var bar = pdp && $('[data-ps-satc]', pdp);
    if (bar) {
      doc.body.appendChild(bar);
      var price = $('[data-ps-satc-price]', bar), sbtn = $('[data-ps-satc-btn]', bar);
      var syncPrice = function () { price.textContent = ' — ' + totalEl.textContent.trim(); };
      syncPrice(); doc.addEventListener('pawsy:tier', syncPrice);
      sbtn.addEventListener('click', function () { atc.click(); });
      var past = false;
      var apply = function () {
        var drawer = doc.querySelector('#ps-cart.is-open');
        var show = past && !drawer;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        sbtn.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver(function (es) { var e = es[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); }).observe(atc);
      var cart = doc.getElementById('ps-cart');
      cart && new MutationObserver(apply).observe(cart, { attributes: true, attributeFilter: ['class'] });
    }
  });

  /* ---------- in-page links to the buy box scroll smoothly ---------- */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var t = doc.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    var y = t.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });

  /* ---------- scroll reveal: the cover slides off as the frame crosses the viewport ---------- */
  var reveals = $$('[data-ps-reveal]');
  if (reveals.length) {
    var tickReveal = function () {
      var vh = window.innerHeight;
      reveals.forEach(function (r) {
        var b = r.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (vh - b.top) / (vh + b.height) * 1.6 - 0.3));
        r._max = Math.max(r._max || 0, p);
        r.style.setProperty('--ps-reveal', (r._max * 100).toFixed(1) + '%');
      });
    };
    window.addEventListener('scroll', function () { window.requestAnimationFrame(tickReveal); }, { passive: true });
    tickReveal();
  }

  /* ---------- ingredient carousel ---------- */
  $$('[data-ps-ing]').forEach(function (root) {
    var slides = $$('[data-ps-ing-slide]', root), infos = $$('[data-ps-ing-info]', root);
    var strip = $('[data-ps-ing-strip]', root);
    var i = 0;
    function show(k) {
      i = (k + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      infos.forEach(function (s, n) { s.hidden = n !== i; });
      var s = slides[i];
      strip.scrollTo({ left: s.offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ps-ing-next]')) show(i + 1);
      else if (e.target.closest('[data-ps-ing-prev]')) show(i - 1);
      else { var s = e.target.closest('[data-ps-ing-slide]'); if (s) show(slides.indexOf(s)); }
    });
  });

  /* ---------- accordions that keep one item open ---------- */
  $$('[data-ps-exclusive]').forEach(function (list) {
    list.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      $$('details', list).forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });
})();
